import { createApi } from "@reduxjs/toolkit/query/react";
import { queryParams } from "../../../utils/helper";
import { baseQueryWithAuth } from "../../BaseQueryWithAuth/baseQueryWithAuth";

export const reviewApiService = createApi({
  reducerPath: "reviewApi",
  baseQuery: baseQueryWithAuth,
  endpoints: (builder) => ({
    createReview: builder.mutation({
      query: ({ payload, params }) => {
        let query = queryParams(params);
        return {
          url: `review/create${query}`,
          method: "POST",
          body: payload,
        };
      },
    }),
    getReviews: builder.query({
      query: ({ course, rating, date, type, params }) => {
        let query = queryParams(params);
        return {
          url: `review/get/all/${course}/${rating}/${date}/${type}${query}`,
          method: "GET",
        };
      },
    }),
  }),
});

export const { useCreateReviewMutation, useGetReviewsQuery } = reviewApiService;
